/* Custom collection sort dropdown — panel matches Refine (white card, check rows).
   The desktop filter sidebar is sticky; parking avoids ancestor transform/filter traps.
   While open the panel is moved to document.body so viewport coords are correct. */
(function () {
  if (window.__motSortInit) return;
  window.__motSortInit = true;

  var DESKTOP_MIN = 1241;
  var mqlDesktop = window.matchMedia ? window.matchMedia('(min-width: ' + DESKTOP_MIN + 'px)') : null;
  var openRoot = null;
  var opening = false;
  var prefersReducedMotion = false;
  try {
    prefersReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch (_) {}

  function isDesktop() {
    return mqlDesktop ? mqlDesktop.matches : window.innerWidth >= DESKTOP_MIN;
  }

  function cssVarNumber(el, name, fallback) {
    var v = getComputedStyle(el).getPropertyValue(name).trim();
    var n = parseFloat(v);
    return Number.isFinite(n) ? n : (fallback || 0);
  }

  function getStickyTop() {
    var fromSticky = cssVarNumber(document.documentElement, '--collection-sticky-top', 0);
    if (fromSticky) return fromSticky;
    var header = document.getElementById('header');
    var headerH = header ? header.getBoundingClientRect().height : cssVarNumber(document.documentElement, '--header-h', 0);
    return headerH ? headerH + 20 : 0;
  }

  function isPositionFixed(el) {
    var node = el;
    while (node && node !== document.documentElement) {
      if (getComputedStyle(node).position === 'fixed') return true;
      node = node.parentElement;
    }
    return false;
  }

  function scrollTriggerIntoFixedPosition(trigger, timeoutMs) {
    timeoutMs = timeoutMs || 1200;
    return new Promise(function (resolve) {
      if (!trigger) return resolve(false);
      var targetTop = getStickyTop();
      var currentTop = trigger.getBoundingClientRect().top;
      if (isPositionFixed(trigger) || Math.abs(currentTop - targetTop) <= 1) {
        return resolve(true);
      }
      var dest = Math.max(0, window.scrollY + currentTop - targetTop);
      var done = false;
      var pollId = null;
      var mqHandler = null;
      function finish(ok) {
        if (done) return;
        done = true;
        cleanup();
        resolve(!!ok);
      }
      function onScroll() {
        var t = trigger.getBoundingClientRect().top;
        if (isPositionFixed(trigger) || Math.abs(t - targetTop) <= 1) finish(true);
      }
      function cleanup() {
        window.removeEventListener('scroll', onScroll);
        if ('onscrollend' in window) window.removeEventListener('scrollend', finishBound);
        if (pollId) { clearInterval(pollId); pollId = null; }
        if (mqHandler && mqlDesktop) {
          if (mqlDesktop.removeEventListener) mqlDesktop.removeEventListener('change', mqHandler);
          else if (mqlDesktop.removeListener) mqlDesktop.removeListener(mqHandler);
        }
      }
      function finishBound() { finish(true); }
      function startPoll() {
        var tries = 0;
        pollId = window.setInterval(function () {
          tries++;
          onScroll();
          if (tries > 40) { clearInterval(pollId); pollId = null; finish(true); }
        }, 50);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      if ('onscrollend' in window) window.addEventListener('scrollend', finishBound, { passive: true });
      else startPoll();
      setTimeout(function () { finish(true); }, timeoutMs);
      try {
        window.scrollTo({ top: dest, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
      } catch (_) {
        window.scrollTo(0, dest);
      }
      mqHandler = function (e) { if (e.matches) finish(false); };
      if (mqlDesktop) {
        if (mqlDesktop.addEventListener) mqlDesktop.addEventListener('change', mqHandler);
        else if (mqlDesktop.addListener) mqlDesktop.addListener(mqHandler);
      }
    });
  }

  function roots() {
    return document.querySelectorAll('.sortedBy.mot-sort');
  }
  function buttonOf(root) {
    return root.querySelector('.mot-sort__button');
  }
  function panelOf(root) {
    if (root._motPanel && root._motPanel.isConnected) return root._motPanel;
    var panel = root.querySelector('.mot-sort__panel');
    if (panel) root._motPanel = panel;
    return root._motPanel || null;
  }
  function optionsOf(root) {
    var panel = panelOf(root);
    return panel ? panel.querySelectorAll('.mot-sort__option') : [];
  }
  function hostOf(root) {
    return root.querySelector('.mot-sort__control');
  }

  function parkPanel(root) {
    var panel = panelOf(root);
    if (!panel) return;
    if (!panel._motSortHost) panel._motSortHost = hostOf(root);
    if (panel.parentNode !== document.body) document.body.appendChild(panel);
  }

  function unparkPanel(root) {
    var panel = panelOf(root);
    if (!panel) return;
    var host = panel._motSortHost || hostOf(root);
    if (host && panel.parentNode !== host) host.appendChild(panel);
  }

  function close(root) {
    if (!root) return;
    root.classList.remove('is-open');
    var btn = buttonOf(root);
    var panel = panelOf(root);
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (panel) {
      panel.hidden = true;
      panel.style.left = '';
      panel.style.top = '';
      panel.style.width = '';
    }
    unparkPanel(root);
    if (openRoot === root) openRoot = null;
  }

  function closeAll(except) {
    roots().forEach(function (root) {
      if (root !== except) close(root);
    });
  }

  function placePanel(root) {
    var btn = buttonOf(root);
    var panel = panelOf(root);
    if (!btn || !panel) return;
    var r = btn.getBoundingClientRect();
    var gap = 6;
    var pad = 8;
    var pw = Math.min(275, Math.max(220, r.width));
    var left = r.left;
    if (left + pw > window.innerWidth - pad) left = r.right - pw;
    if (left < pad) left = pad;
    if (left + pw > window.innerWidth - pad) {
      pw = Math.max(r.width, window.innerWidth - pad - left);
    }
    panel.style.width = pw + 'px';
    panel.style.left = left + 'px';
    panel.style.right = 'auto';
    panel.style.top = r.bottom + gap + 'px';
    panel.style.bottom = 'auto';
    var ph = panel.getBoundingClientRect().height;
    if (r.bottom + gap + ph > window.innerHeight - pad) {
      var above = r.top - gap - ph;
      if (above >= pad) panel.style.top = above + 'px';
    }
  }

  function open(root) {
    closeAll(root);
    var btn = buttonOf(root);
    var panel = panelOf(root);
    if (!btn || !panel) return;
    parkPanel(root);
    panel.hidden = false;
    root.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    openRoot = root;
    placePanel(root);
    var selected = panel.querySelector('.mot-sort__option[aria-selected="true"]') || panel.querySelector('.mot-sort__option');
    if (selected) selected.focus();
  }

  function toggle(root) {
    if (!root) return;
    if (root.classList.contains('is-open')) {
      close(root);
      return;
    }
    if (isDesktop()) {
      open(root);
      return;
    }
    if (opening) return;
    opening = true;
    scrollTriggerIntoFixedPosition(buttonOf(root)).then(function () {
      opening = false;
      if (isDesktop()) return;
      open(root);
    });
  }

  function applyValue(root, value, label) {
    var current = root.querySelector('.mot-sort__current');
    if (current && label) current.textContent = label;
    optionsOf(root).forEach(function (opt) {
      var on = opt.getAttribute('data-value') === value;
      opt.classList.toggle('selected', on);
      opt.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var select = root.querySelector('select.sort-by, select.mot-sort__select');
    if (!select || select.value === value) {
      close(root);
      return;
    }
    select.value = value;
    document.querySelectorAll('select.sort-by').forEach(function (other) {
      other.value = value;
    });
    close(root);
    if (window.jQuery) {
      window.jQuery(select).trigger('change');
    } else {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mot-sort__button');
    if (btn) {
      e.preventDefault();
      toggle(btn.closest('.sortedBy.mot-sort'));
      return;
    }
    var opt = e.target.closest('.mot-sort__option');
    if (opt) {
      e.preventDefault();
      var root = opt.closest('.sortedBy.mot-sort') || openRoot;
      if (!root) return;
      var labelEl = opt.querySelector('.mot-sort__option-label');
      applyValue(root, opt.getAttribute('data-value'), labelEl ? labelEl.textContent : opt.textContent.trim());
      return;
    }
    if (openRoot && !e.target.closest('.sortedBy.mot-sort') && !e.target.closest('.mot-sort__panel')) {
      close(openRoot);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openRoot) {
      if (e.key === 'ArrowDown' && e.target.classList && e.target.classList.contains('mot-sort__button')) {
        e.preventDefault();
        open(e.target.closest('.sortedBy.mot-sort'));
      }
      return;
    }
    var opts = Array.prototype.slice.call(optionsOf(openRoot));
    var i = opts.indexOf(document.activeElement);
    if (e.key === 'Escape') {
      e.preventDefault();
      var btn = buttonOf(openRoot);
      close(openRoot);
      if (btn) btn.focus();
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      opts[Math.min(opts.length - 1, Math.max(0, i + 1))].focus();
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      opts[Math.max(0, i < 0 ? 0 : i - 1)].focus();
    } else if (e.key === 'Home') {
      e.preventDefault();
      if (opts[0]) opts[0].focus();
    } else if (e.key === 'End') {
      e.preventDefault();
      if (opts.length) opts[opts.length - 1].focus();
    } else if (e.key === 'Enter' || e.key === ' ') {
      if (document.activeElement && document.activeElement.classList.contains('mot-sort__option')) {
        e.preventDefault();
        document.activeElement.click();
      }
    } else if (e.key === 'Tab') {
      close(openRoot);
    }
  });

  window.addEventListener('resize', function () {
    if (openRoot) placePanel(openRoot);
  });
  window.addEventListener('scroll', function () {
    if (openRoot) placePanel(openRoot);
  }, true);
})();
